import EventSet from './EventSet';

export default class EventPool {
  static createByType = (poolName, eventType, eventHandlers) => {
    const handlerSets = new Map();
    handlerSets.set(eventType, new EventSet(eventHandlers));

    return new EventPool(poolName, handlerSets);
  };

  constructor(poolName, handlerSets) {
    this.handlerSets = handlerSets;
    this.poolName = poolName;
  }

  addHandlers(eventType, eventHandlers) {
    const handlerSets = new Map(this.handlerSets);

    if (handlerSets.has(eventType)) {
      handlerSets.set(
        eventType,
        handlerSets.get(eventType).addHandlers(eventHandlers)
      );
    } else {
      handlerSets.set(eventType, new EventSet(eventHandlers));
    }

    return new EventPool(this.poolName, handlerSets);
  }

  dispatchEvent(eventType, event) {
    const handlerSet = this.handlerSets.get(eventType);

    if (handlerSet)
      handlerSet.dispatchEvent(event, this.poolName === 'default');
  }

  hasHandlers() {
    return this.handlerSets.size > 0;
  }

  removeHandlers(eventType, eventHandlers) {
    const handlerSets = new Map(this.handlerSets);

    if (!handlerSets.has(eventType)) {
      return new EventPool(this.poolName, handlerSets);
    }

    const handlerSet = handlerSets.get(eventType).removeHandlers(eventHandlers);

    if (handlerSet.hasHandlers()) {
      handlerSets.set(eventType, handlerSet);
    } else {
      handlerSets.delete(eventType);
    }

    return new EventPool(this.poolName, handlerSets);
  }
}
